/**
 *
 * @module submitOrderRequest
 *
 */

import Check from 'check-types';
import PassThroughData from './passThroughData';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    nonEmptyString,
    instanceStrict
} = Check.assert;

/**
 *
 * @class SubmitOrderRequest
 *
 */
export default class SubmitOrderRequest {

    /**
     *
     * @param {String} creditCardNumber
     * @param {String} clientId
     * @param {SDK.Services.Commerce.PassThroughData} passthroughData
     * @throws {InvalidArgumentException}
     * @note passthroughData is not camelCased to match the service
     *
     */
    constructor(creditCardNumber, clientId, passthroughData) {

        const errorMessage = {
            ctor: 'SubmitOrderRequest(creditCardNumber, clientId, passthroughData)',
            get creditCardNumber() {
                return `${this.ctor} creditCardNumber should be a String with length`;
            },
            get clientId() {
                return `${this.ctor} clientId should be a String with length`;
            },
            get passthroughData() {
                return `${this.ctor} needs SDK.Services.Commerce.PassThroughData instance`;
            }
        };

        nonEmptyString(creditCardNumber, errorMessage.creditCardNumber, InvalidArgumentException);
        nonEmptyString(clientId, errorMessage.clientId, InvalidArgumentException);

        instanceStrict(
            passthroughData,
            PassThroughData,
            errorMessage.passthroughData,
            InvalidArgumentException
        );

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.creditCardNumber = creditCardNumber;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.clientId = clientId;

        /**
         *
         * @access public
         * @type {SDK.Services.Commerce.PassThroughData}
         *
         */
        this.passthroughData = passthroughData;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/submitOrderRequest.js